/*
 * Why an add-user request failed, in the terms the UI has to explain it in.
 * Distinct from the HTTP status: workspace-service answers with 403 for two
 * unrelated reasons, and a cross-account session (BUG-801) produces a third
 * that the status alone cannot express.
 */
export enum eAddUserFailure {
  NO_SEATS = 'no-seats',
  SESSION_MISMATCH = 'session-mismatch',
  NOT_IN_WORKSPACE = 'not-in-workspace',
  NO_PERMISSION = 'no-permission',
  UNKNOWN = 'unknown',
}

/**
 * How the seat-purchase leg of an at-limit add ended.
 *
 * These are not error codes — they are the two states where the modal must STAY OPEN
 * with the customer's details intact, because the ordinary teardown would leave the
 * offered retry with nothing to retry against.
 */
export enum eSeatFlowOutcome {
  /** No seat purchase involved, or it completed and the invite went out. */
  NONE = 'none',
  /**
   * The bank said no. No seat, no invite, nothing charged — and the customer is one
   * retry or one different card away from the thing they came to do.
   */
  DECLINED = 'declined',
  /**
   * The seat was bought and the invitation failed. The capacity is genuinely paid
   * for, so the retry invites only and must never charge again (KD7).
   */
  SEAT_PURCHASED_INVITE_FAILED = 'seat-purchased-invite-failed',
}
